import { render, staticRenderFns } from "./selaConceptStats.vue?vue&type=template&id=8f97b7b2&scoped=true"
import script from "./selaConceptStats.vue?vue&type=script&lang=js"
export * from "./selaConceptStats.vue?vue&type=script&lang=js"
import style0 from "./selaConceptStats.vue?vue&type=style&index=0&id=8f97b7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f97b7b2",
  null
  
)

export default component.exports